import React from 'react';
import { Link } from 'react-router-dom';
import './OurVision.css';

const OurVision = () => {
  return (
    <div className="page-container">
      <div className="page-content">
        <div className="page-main">
          <section className="page-section">
            <h1 className="page-title">Our Vision</h1>
            <div className="page-text-content">
              <p>
                At NQC (Nova Quality Certification Agency), our vision is to be the global leader in 
                certification services, renowned for our integrity, expertise, and innovation. We aspire 
                to set the benchmark for excellence in the industry by providing unparalleled ISO, CE, 
                Testing, Auditing, and Evaluation services that empower businesses to achieve and maintain 
                the highest standards of quality and compliance.
              </p>
            </div>
          </section>

          <section className="page-section">
            <h2 className="page-section-title">We envision a future where:</h2>
            <div className="vision-list">
              <div className="vision-item">
                <h3 className="vision-title">Excellence is Standard</h3>
                <p className="vision-description">
                  Businesses across the world consistently achieve and exceed international standards, 
                  driven by our comprehensive certification services.
                </p>
              </div>
              <div className="vision-item">
                <h3 className="vision-title">Trust is Universal</h3>
                <p className="vision-description">
                  Our certifications are universally recognized and trusted, facilitating seamless market 
                  access and consumer confidence for our clients.
                </p>
              </div>
              <div className="vision-item">
                <h3 className="vision-title">Innovation Thrives</h3>
                <p className="vision-description">
                  Organizations leverage cutting-edge practices and technologies, supported by our 
                  forward-thinking certification processes.
                </p>
              </div>
              <div className="vision-item">
                <h3 className="vision-title">Sustainability is Key</h3>
                <p className="vision-description">
                  Sustainable and responsible business practices are the norm, contributing to a healthier 
                  planet and society.
                </p>
              </div>
              <div className="vision-item">
                <h3 className="vision-title">Growth is Continuous</h3>
                <p className="vision-description">
                  Businesses continually grow and improve, guided by our expertise and commitment to 
                  their success.
                </p>
              </div>
            </div>
          </section>

          <section className="page-section">
            <div className="page-text-content">
              <p>
                By realizing this vision, NQC (Nova Quality Certification Agency) aims to play a pivotal 
                role in shaping a world where quality, safety, and compliance are the foundation of all 
                successful enterprises.
              </p>
            </div>
          </section>
        </div>

        <aside className="page-sidebar">
          <div className="sidebar-section">
            <h2 className="sidebar-title">Our Services</h2>
            <ul className="sidebar-links">
              <li><Link to="/system-certification">System Certification</Link></li>
              <li><Link to="/product-certification">Product Certification</Link></li>
              <li><Link to="/quality-certification">Quality Certification</Link></li>
            </ul>
          </div>
        </aside>
      </div>
    </div>
  );
};

export default OurVision;

